module.exports = __webpack_public_path__ + "static/img/e2.436b153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/e2.png
// module id = cgA+
// module chunks = 0